import { deleteCookie, setCookie } from '../../helpers/cookie_helper';

(() => {
  if (!document.querySelector('body').classList.contains('content-structure')) {
    return;
  }
  // eslint-disable-next-line no-undef
  new Foundation.Accordion($('[data-accordion]'));

  const createOrUpdateCookie = event => {
    if (window.Sofatutor.consentGivenForCategory('necessary')) {
      const value = event.currentTarget.dataset.urlTitle;
      setCookie('_sofatutor_subject_level', value, { path: '/' });
    }
  };

  const handleToggleDropdown = () => {
    document
      .querySelector('.content-structure-class-levels')
      .classList.toggle('is-hidden');
  };

  document
    .querySelector('.js-all-classes')
    ?.addEventListener('click', () =>
      deleteCookie('_sofatutor_subject_level=')
    );

  document.querySelectorAll('.js-class-level').forEach(element => {
    element.addEventListener('click', createOrUpdateCookie);
  });

  document
    .querySelectorAll('.js-content-structure-accordion')
    .forEach(element => {
      element.addEventListener('click', () => {
        new window.Sofatutor.Classes.TruncatedCardTitle();
      });
    });

  document
    .querySelector('.content-structure-header__dropdown')
    ?.addEventListener('click', handleToggleDropdown);
})();
